import React , { useState , useEffect} from "react";
import { baseUrl } from "../../utils.jsx/baseUrl";
import axios from 'axios'
const token = sessionStorage.getItem('token');
import { OriginIcon , DropIcon } from "../svg/icons/icon";
import GoogleMaps from "./GoogleMaps";
import { SortingDownIcon , SortingUpIcon } from "../svg/icons/icon";

// const getCSTTime = (last_updated) => {
//     let date = new Date(last_updated);
//     const temp = new Date(date.getTime() - 5 * 60 * 60 * 1000);
//     const day = temp.getUTCDate() <= 9 ? `0${temp.getUTCDate()}` : `${temp.getUTCDate()}`;
//     const month = temp.getUTCMonth();
//     const year = temp.getUTCFullYear();
//     let hour = temp.getUTCHours() > 12 ? temp.getUTCHours() - 12 : temp.getUTCHours();
//     hour = hour <= 9 ? `0${hour}` : hour;
//     const minute = temp.getUTCMinutes() <= 9 ? `0${temp.getUTCMinutes()}` : `${temp.getUTCMinutes()}`;
//     const month_name = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//     const moment = temp.getUTCHours() < 12 ? 'am' : 'pm';
//     const convertedTime = `${day}-${month_name[month]}-${year}, ${hour}:${minute} ${moment}`; 
//     return convertedTime;
// }

const getCSTTime = (last_updated) => {
  let date = new Date(last_updated);
  
  // Convert to CST (UTC-6 or UTC-5 during daylight saving time)
  const temp = new Date(date.getTime() - 6 * 60 * 60 * 1000);
  
  const month = temp.getUTCMonth() + 1; // getUTCMonth() returns 0-11, so add 1
  const day = temp.getUTCDate();
  const year = temp.getUTCFullYear();

  // Format with leading zeroes if needed
  const formattedDate = `${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}-${year}`;

  return formattedDate;
}


const SinglepointLoadsTable = ({ headers , data  }) => {
   const token = localStorage.getItem("token")
  const [showDetailIndex, setShowDetailIndex] = useState(null); 
  const [singleLoad , setSingleLoad]  = useState();
  const [showMap , setShowMap] = useState(false);
  const [origin , setOrigin] = useState();
  const [destination , setDestination] = useState();

  const toggleDescription = (index , id) => {
    setShowDetailIndex(showDetailIndex === index ? null : index); 
    (async() =>{
      try{
        const url = `${baseUrl.url}/singlepoint/loads/get/${id}`
        const response = await axios.get(url , {
            headers : {
              Authorization : `Bearer ${token}`,
            }
        })
        setSingleLoad(response.data)
        setOrigin({
                latitude  : response.data.origin_latLng[0],
                longitude : response.data.origin_latLng[1],
            })
        setDestination({
                latitude  : response.data.destination_latLng[0],
                longitude : response.data.destination_latLng[1],    
            })

      }catch(error){
        console.log(error)
      }
    })()
  };


  return (
    <table className="mt-10 w-full bg-white rounded-2xl font-sans">
      <thead>
        <tr className="shadow-2xl mb-1 cursor-pointer border-b-2 rounded-2xl border-gray-300">
          {headers.map((item, index) => (
            <th key={index} className="whitespace-nowrap mb-4 text-left px-4 py-4">
  <span className="flex flex-row items-center">
    {item}
   
  </span>
</th>

          ))}    
    </tr>
      </thead>
      <tbody>
        {data?.data?.length != 0  && data?.data?.map((row, index) => (
          <React.Fragment key={index}>
            <tr
            className={` ${showDetailIndex === index ? "bg-[#D8F1FF] cursor-pointer" : "odd:bg-[#F7FBFF] cursor-pointer"}`}
              onClick={() => {
                toggleDescription(index , row._id)
              }}
            >
              <td className="whitespace-nowrap text-left px-4 py-4">{`${row.origin}`}</td>
              <td className="whitespace-nowrap text-left px-4 py-4">{`${row.destination}`}</td>
              <td className="whitespace-nowrap text-left px-4 py-4">{getCSTTime(row.pickup_date)}</td>
              <td className="whitespace-nowrap text-left px-4 py-4">{row.company_name} </td> 
              <td className="whitespace-nowrap text-left  px-4 py-4">{row.equipment_type}</td>
               <td className="whitespace-nowrap text-left px-4 py-4">{row.posted_by}</td>
               <td className="whitespace-nowrap text-left px-4 py-4">{getCSTTime(row.updatedAt)}</td> 
             
            </tr>

            {showDetailIndex === index && (
              <tr className = "bg-[#D8F1FF]">
                <td colSpan = {headers.length} className="bg-[#D8F1FF] p-2">
                  <div className="bg-white px-2 py-1  rounded grid grid-cols-2 justify-stretch  gap-10 ">
                     <div className = "flex flex-col p-2">
                       <h1 className = "text-2xl"><strong>{singleLoad?.company_name}</strong></h1>
                       <div className = 'pt-4  grid grid-cols-2 justify-stretch'>
                       <div className = " pr-6  border-r-2 ">                                                        
                          <span className = "text-[12px] text-[#258CFB] ">Company Details</span>
                          <div className="pt-2">
                           <div className = "flex flex-row  justify-between">
                          <span className = "text-[#737373] text-[14px]">Email: </span>
                          <span className = "text-[14px]">{`logistics@singlepointgroup.com`}</span>
                          </div>
                          <div className = "flex flex-row  justify-between">
                          <span className = "text-[#737373] text-[14px]">Phone Number: </span>
                          <span className = "text-[14px]">{`(832) 631-9889`}</span>
                          </div>
                          </div>
                       </div>
                      <div className = "pl-6"> 
                         <span className = "text-[12px] text-[#258CFB]">Other Details</span>
                         <div className = "pt-2">
                         <div className="flex flex-row justify-between">
                          <span className = "text-[#737373] text-[14px]">Total Load:</span>
                          <span className = "text-[14px]">{singleLoad?.load_size  }</span>
                          </div>
                         
                          <div className="flex flex-row justify-between">
                          <span className = "text-[#737373] text-[14px]">Dispatcher:</span>
                          <span className = "text-[14px]">{`Single Point Logistics`}</span>
                          </div>
                          </div>
                       </div>
                       </div>
                   </div>
                   <div className = "flex flex-row p-2">
                    <div className = 'pt-4  grid grid-rows-2 justify-stretch'>
                    <span>Location Range</span>
                    <div className = "flex flex-col pr-6">
                      <span className = "flex flex-row gap-2 text-[12px] text-[#737373]">
                        <span className = ""><OriginIcon /></span>
                        <span>Pickup from</span>
                        </span>

                    {singleLoad && singleLoad.origin &&  <span className = "text-[14px] pl-5">{`${singleLoad.origin}`}</span>}
                    </div>
                    <div className = "border-l-2 border-dotted m-1"></div>
                    <div className = "flex flex-col pr-6 pt-2 ">
                    <span className = "flex flex-row gap-2 text-[12px] text-[#737373]">
                      <span className = ""><DropIcon /></span>
                      <span>Dropoff at</span>
                      </span>
                     {singleLoad && singleLoad.destination &&  <span className = "text-[14px] pl-5">{`${singleLoad.destination} `}</span>}

                    </div>
                  <button className="h-[38px] w-max p-4 bg-[#258CFB] mt-2 flex justify-center items-center rounded-lg text-[#ffffff]" onClick = {()=>setShowMap(!showMap)}>{showMap ? "Hide Map route" : "Show map route"}</button>

                  </div>
                  <div className = "">
                   {showMap &&

                  <div className = "w-[400px]"> <GoogleMaps  origin = {origin} destination = {destination}/> </div>
              
                }
                </div>
                   </div>
                  </div>
              
                </td>
              </tr>
            )}
          </React.Fragment>
        ))
    
      }
      {data?.data?.length == 0  && 
       <tr>
        <td colSpan={headers.length} className="px-4 py-4 m-4 text-center">
            No loads available.  
        </td>
         </tr>
      }

     
       
      </tbody>
    </table>
  );
};

export default SinglepointLoadsTable;

